import {
    parseMoment,
    toDate,
    makeMinuteTimeSpan,
} from 'commons/js/util/dateConverter'
import { applyModifier } from './applyModifier'

import moment from 'moment'

const MINUTES_STEP = 30
export function buildDatesBetween (start, end, duration, acum = []) {
    if (start.isAfter(end)) {
        return acum
    }

    acum.push(start.clone())

    return buildDatesBetween(
        start.clone().add(duration),
        end,
        duration,
        acum,
    )
}

export const calculateSelectedHourOption = (date, options) => {
    const nowHour = moment(date)
    return options.find(opt => moment(opt).isSameOrAfter(nowHour, 'minute'))
}

export function buildHoursAndMinutes (day, disabledHours) {
    const startOfDay = parseMoment(day).startOf('day')
    const endOfDay = parseMoment(day).endOf('day')
    const duration = makeMinuteTimeSpan(MINUTES_STEP)
    const dates = buildDatesBetween(startOfDay, endOfDay, duration)

    return dates
        .map((date) => toDate(date))
        .filter((date) => !applyModifier(date, disabledHours))
}
